// appels/create: the « Créer un appel » form, its rules and the request it sends.
import { toAlgiersIso, type DateAndTime } from "@core/utils";

export interface CreateAppelValues {
  name: string;
  opening: DateAndTime;
  closing: DateAndTime;
}

/** The opening and closing times the dialog starts with (Figma: 09:00 and 23:59). */
export function initialValues(name: string): CreateAppelValues {
  return {
    name,
    opening: { date: "", time: "09:00" },
    closing: { date: "", time: "23:59" },
  };
}

export interface CreateAppelErrors {
  opening?: string;
  openingTime?: string;
  closing?: string;
  closingTime?: string;
}

/**
 * What is wrong with the form, as codes under `errors.` in the `appels` namespace. The name is
 * optional (the server numbers a blank one). The closing must come after the opening; the API
 * checks the same, and the comparison is on the instants, so a closing on the same day later in the
 * evening is fine.
 */
export function validateCreate(values: CreateAppelValues): CreateAppelErrors {
  const errors: CreateAppelErrors = {};
  if (values.opening.date === "") errors.opening = "date_required";
  if (values.opening.time === "") errors.openingTime = "time_required";
  if (values.closing.date === "") errors.closing = "date_required";
  if (values.closing.time === "") errors.closingTime = "time_required";

  const opening = toAlgiersIso(values.opening);
  const closing = toAlgiersIso(values.closing);
  if (opening && closing && new Date(closing) <= new Date(opening)) {
    errors.closing = "closing_before_opening";
  }
  return errors;
}

/** The request body. A blank name is left out, so the server numbers the appel. */
export function toCreateRequest(
  values: CreateAppelValues
): Record<string, string> {
  const body: Record<string, string> = {
    opening_at: toAlgiersIso(values.opening) ?? "",
    closing_at: toAlgiersIso(values.closing) ?? "",
  };
  const name = values.name.trim();
  if (name !== "") body.name = name;
  return body;
}
